import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { MdPaginator, MdSnackBar } from "@angular/material";
import { DataSource } from "@angular/cdk/collections";
import { IncassoListItemModel } from "../../models/incassi/incasso-list-item.model";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { BrogliacciService } from './../../services/brogliacci.service';
import { IncassiService } from "../../services/incassi.service";
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { BrogliaccioDistintaModel } from "../../models/brogliacci/brogliaccio-distinta.model";
import { IncassoModel } from "../../models/incassi/incasso.model";
import { Router } from "@angular/router";
import { DistinteIncassiService } from "../../services/distinte-incassi.service";
import { Configurations } from "../../core/configurations";
import { UltimaVersioneApplicativoClientService } from '../../services/ultima-versione-applicativo-client.service';


///////////////////////
//TODO:
//1- in fase di creazione non vado a cambiare lo stato della del brogliaccio associata alla nuova distinta I
//questo significa che potenzialmente possono essere create più DI in corrispondenza 
//di una stesso brogliaccio, fino a quando non viene confermata
//come gestire la cosa?
//////////////////////

@Component({
  selector: 'app-distinta-versamenti-new-detail',
  templateUrl: './distinta-versamenti-new-detail.component.html',
  styleUrls: ['./distinta-versamenti-new-detail.component.css']
})

export class DistintaVersamentiNewDetailComponent implements OnInit {
  //nuova distinta
  distintaCorrente = new BrogliaccioDistintaModel();
  //elementi per la tabella brogliacci
  displayedColumns = ['id', 'data', 'agente', 'totaleValuta', 'totaleAssegni', 'totale', 'includi', 'dettaglio', 'elimina'];
  dataSource: BrogliacciAssociabili | null;
  isAllInclusive = new BehaviorSubject<boolean>(false);
  //salvataggio
  saving: boolean;  //disabilitazione momentanea durante il salvataggio
  incassiSelezionati: string[];
  isLoading:Boolean=false;
  constructor(
    private configuration: Configurations,
    //private _incassiService: IncassiService, 
    private _brogliacciService: BrogliacciService,
    private _incassiService: IncassiService,
    private _distinteService: DistinteIncassiService,
    private snackBar: MdSnackBar,
    private router: Router,
    private _ultimaVersioneClientTipo:UltimaVersioneApplicativoClientService
    ) { }

  @ViewChild(MdPaginator) paginator: MdPaginator;

  /* LOAD DATA */
  ngOnInit() {
    //alert("pagina dettaglio distinta versamenti");
    this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
    .subscribe(data => {
      Configurations.currentVersionCod=data.codice;
      let v=localStorage.getItem('clientVersion');
      if(v===null||v===undefined||v!==data.codice) {
        localStorage.setItem('clientVersion',data.codice);
        alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
        window.location.href=Configurations.baseUrl;
        
      }
    });
    this.isLoading=true;
    //lista brogliacci associabili
    this._brogliacciService.getBrogliacciAssociabiliList()
      .subscribe(
      (r: BrogliaccioDistintaModel[]) => {
        this.dataSource = new BrogliacciAssociabili(r, null);
        this.isLoading=false;
      },
      error => {
        this.showError("Errore durante la procedura di caricamento dei dati");
        this.isLoading=false;
      }

      );
  }

  /* CALCOLA TOTALI */
  getTotal(): number {
    let tot = 0;
    if (this.dataSource && this.dataSource.brogliacci) {
      this.dataSource.brogliacci.subscribe(d => d.forEach(i => {
        if (!isNaN(i.totale) && i.stato.id === 3) {
          tot += i.totale;
        }
      }));
      this.distintaCorrente.totale = tot;
      //if(tot>0)
      //  this.canSave= true;
      //else this.canSave= false;
    }
    return tot;
  }
  getTotalAssegni(): number {
    let tot = 0;
    if (this.dataSource && this.dataSource.brogliacci) {
      this.dataSource.brogliacci.subscribe(d =>
        d.forEach(i => {
          if (!isNaN(i.totaleAssegni) && i.stato.id === 3) {
            tot += i.totaleAssegni;
          }
        }));
      this.distintaCorrente.totaleAssegni = tot;
    }
    return tot;
  }
  getTotalContanti(): number {
    let tot = 0;
    if (this.dataSource && this.dataSource.brogliacci) {
      this.dataSource.brogliacci.subscribe(d => d.forEach(i => {
        if (!isNaN(i.totaleValuta) && i.stato.id === 3) {
          tot += i.totaleValuta;
        }
      }));
      this.distintaCorrente.totaleValuta = tot;
    }
    return tot;
  }

  /* COMANDI CHECK (inclusione brogliacci alla distinta) */
  includi(ev,row: BrogliaccioDistintaModel) {
    let target=ev.target;

    if (target.checked) {
      row.stato.id = 3;
    } else {
      row.stato.id = 2;
    }
  }
  includiTutto(e) {
    if (this.dataSource && this.dataSource.brogliacci) {
      this.dataSource.brogliacci.subscribe(d => d.forEach(i => {
        i.stato.id = e.target.checked ? 3 : 2;
      }));
      this.isAllInclusive.next(e.target.checked);
    }
  }

  /* SALVATAGGIO */
  creaDistintaVersamenti(): void {
    if (this.distintaCorrente.totale === 0 || !this.dataSource.brogliacci) {
      this.showError("Errore. Selezionare almeno un brogliaccio.");
    } else {
      this.saving = true;
      this.distintaCorrente.incassi = [];
      this.distintaCorrente.stato = { id: 1, codice: "N", descrizione: "Nuovo" };
      this.distintaCorrente.dataCreazione = new Date();

      //lista brogliacci da assegnare: da passare al servizio che crea la distinta
      let lista = [];
      this.dataSource.brogliacci.subscribe(d => d.forEach(bro => {
        if (bro.stato.id === 3) {
          lista.push(bro.token);
        }
      }));

      //salvo la nuova distinta e ricarico i dati
      this._distinteService.insert(lista)
        .finally(() => this.saving = false)
        .subscribe(
          (data: any) => {
            //verifica esito e redirect al dettaglio
            if (data.result.result === false) {
              this.showError(data.result.message);
              return false;
            } else
              if (data.tokenDistinta === "") {
                this.showError("Errore durante la procedura di creazione della distinta");
                return false;
              } else {
                this.router.navigateByUrl('/distintaversamenti/' + data.tokenDistinta);
                this.showInfo("Salvataggio avvenuto con successo");
              }
          },
          error => {
            this.showError("Errore durante la procedura di creazione della distinta");
            return false;
          } 
          
       
        );
    }
  }

  /* ELIMINAZIONE E DETTAGLIO DI UN BROGLIACCIO */
  eliminaBrogliaccio(model: BrogliaccioDistintaModel) {
    //elimino il brogliaccio (dalla lista) e ricarico la pagina

    this._brogliacciService.eliminaBrogliaccio(model.token).subscribe(
      data => {
        this.showInfo("Eliminazione avvenuta correttamente");
        this.ngOnInit();
      },
      error => {
        this.showError("Errore durante la procedura di eliminazione del brogliaccio");
        return false;
      }
    );
  }

  apriBrogliaccio(model: BrogliaccioDistintaModel) {
    //vai al dettaglio brogliaccio
    this.router.navigateByUrl('/brogliacci/' + model.token);
  }


  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 2000 });
  }

}

/******************************/
/* DATA SOURCE - lista brogliacci associabili */
export class BrogliacciAssociabili extends DataSource<any> {
  //lista dei brogliacci della distinta
  brogliacci: Observable<BrogliaccioDistintaModel[]>;

  constructor(private data: BrogliaccioDistintaModel[], private _paginator: MdPaginator) {
    super();
  }

  connect(): Observable<BrogliaccioDistintaModel[]> {

    this.brogliacci = Observable.of(this.data);
    return this.brogliacci;
  }
  disconnect() { }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/distinteVersamenti/distinta-versamenti-new-detail.component.ts